import { render, staticRenderFns } from "./TfootTotals.vue?vue&type=template&id=1927cfb2"
import script from "./TfootTotals.vue?vue&type=script&lang=js"
export * from "./TfootTotals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports